// [목적] 폴리오 작성자 표시 라벨 생성 — author 가 있으면 `@handle`, 없으면 익명 라벨
// [이유] 2026-09-18 QA(M-4): 카드·헤더 7곳이 모두 `@{folio.author?.handle ?? folio.slug}` 로
//         작성자가 없을 때 **폴리오 slug 를 유저 핸들처럼** 표기했다(예: 익명 폴리오가 `@SAYgoNJWuh`).
//         slug 는 폴리오 식별자이지 계정이 아니므로 존재하지 않는 사용자를 가리키는 잘못된 정보다.
//         packages/types 의 folioAuthorSchema 는 author=null 을 "탈퇴/익명" 으로 정의하므로 그에 맞춘다.
// [사이드 이팩트] 작성자 없는 폴리오의 표시가 `@<slug>` → `익명` 으로 바뀐다(카드·상세 헤더 공통).
//                 slug 자체는 폴리오 상세 헤더에서 `#<slug>` 로 여전히 별도 노출된다.
// [수정 시 고려사항] 호출부에서 '@' 를 따로 붙이지 말 것 — 이 함수가 접두사까지 포함해 반환한다.
//                    익명 문구를 바꿀 때는 이 파일만 고치면 전 화면에 반영된다.

/** 폴리오 작성자 메타(packages/types folioAuthorSchema 의 부분 구조) */
interface FolioAuthorLike {
  handle: string;
}

export const ANONYMOUS_AUTHOR_LABEL = '익명';

export function folioAuthorLabel(author?: FolioAuthorLike | null): string {
  return author?.handle ? `@${author.handle}` : ANONYMOUS_AUTHOR_LABEL;
}
